import React from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(2.5),
  },
  titleBox: {
    display: "flex",
    alignItems: "center",
    gap: 0,
    flexDirection: "column",
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      gap: theme.spacing(2),
      marginBottom: 0,
    },
  },
  title: {
    fontSize: 32,
    fontWeight: "bold",
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  statusBox: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 2),
    flexShrink: 0,
    marginBottom: 4,
  },
  status: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
  },
  text: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  a: {
    color: theme.palette.primary.main,

    "&:hover": {
      color: theme.palette.primary.light,
    },
  },
}));

export function RequestedBrandedAppContent() {
  const s = useStyles();

  return (
    <Box className={s.header}>
      <Box className={s.titleBox}>
        <Typography className={s.title}>Branded App</Typography>
        <Box className={s.statusBox}>
          <Typography className={s.status}>requested</Typography>
        </Box>
      </Box>
      <Typography className={s.text}>
        Thank you for your interest in a custom branded app! Your request has
        been received and our team will contact you shortly with further
        details.
      </Typography>
      <Typography className={s.text} sx={{ marginTop: 2 }}>
        In the meantime, you can continue using the standard Stridist app for
        your clients. If you have any questions, please contact us at{" "}
        <a className={s.a} href="mailto:accounts@stridist.com">
          accounts@stridist.com
        </a>
        .
      </Typography>
      <Typography className={s.text} sx={{ marginTop: 2 }}>
        We'll reach out to discuss pricing, timeline, and next steps for your
        branded app.
      </Typography>
    </Box>
  );
}
